import type { CatalogReview, PublishedFleet } from '../domain/catalogEvidence';
import type { Vehicle } from '../domain/model';

export function VehicleEvidence({ vehicle }: { vehicle: Vehicle }) {
  if (vehicle.catalogRetire)
    return <small className="evidence-status pending">Altbestand · Ersatz nach Rückkehr</small>;
  if (!vehicle.evidence)
    return (
      <small className="evidence-status simulated">
        Simulationsfahrzeug · Bestand/Rufname unbelegt
      </small>
    );
  return (
    <a
      className="evidence-status published"
      href={vehicle.evidence.sourceUrl}
      target="_blank"
      rel="noreferrer"
      title={`Quelle geprüft am ${vehicle.evidence.checkedAt}; Verfügbarkeit im Spiel simuliert`}
    >
      {vehicle.evidence.unitOnly ? 'HvO-Einheit belegt · Fahrzeug/Rufname offen ↗' : vehicle.evidence.radioIdentifier ? 'Fahrzeug & Kurzkennung belegt · Rufname offen ↗' : vehicle.evidence.callSign
        ? 'Fahrzeug & Rufname laut Quelle ↗'
        : 'Fahrzeug belegt · Rufname offen ↗'}
    </a>
  );
}
export function CatalogEvidence({
  review,
  fleet,
}: {
  review?: CatalogReview;
  fleet?: PublishedFleet;
}) {
  return (
    <div className="catalog-evidence">
      {review && (
        <div className="evidence-summary">
          <span>
            {review.municipality} · {review.federalState}
          </span>
          <span>
            {review.operational === 'inactive'
              ? 'Ehemaliger Standort · keine automatische Ausstattung'
              : review.operational === 'uncertain'
                ? 'Operativer Standort ungeklärt · keine automatische Ausstattung'
                : review.nameMethod === 'published'
                  ? 'Name mit Betreiber-/Verbandsquelle abgeglichen'
                  : review.nameMethod === 'locality'
                    ? 'Ortsname ergänzt · Abteilung nicht amtlich bestätigt'
                    : 'Standort aus OSM · Ortszuordnung geprüft'}
          </span>
          <a href={review.nameSourceUrl} target="_blank" rel="noreferrer">
            Namensquelle ↗
          </a>
          {review.directorySourceUrl && (
            <a href={review.directorySourceUrl} target="_blank" rel="noreferrer">
              Verbandsverzeichnis ↗
            </a>
          )}
        </div>
      )}
      {!fleet ? (
        <p className="evidence-unverified">
          Fahrzeugbestand und Rufnamen noch nicht belegt. Dieser Standort bleibt ohne
          disponierbare Fahrzeuge, bis Bestandsquellen vorliegen.
        </p>
      ) : (
        <details className="published-fleet">
          <summary>Veröffentlichter Bestand · {fleet.vehicles.length} Einträge</summary>
          <p>
            <a href={fleet.sourceUrl} target="_blank" rel="noreferrer">
              {fleet.sourceTitle} ↗
            </a>
            <br />
            Abgerufen: {fleet.checkedAt} ·{' '}
            {fleet.coverage === 'partial' ? 'Teilbestand' : 'Veröffentlichte Liste'} ·
            Einsatzbereitschaft simuliert
          </p>
          {fleet.note && <p>{fleet.note}</p>}
          <div className="inventory-list">
            {fleet.vehicles.map((v) => (
              <div className="inventory-row" key={v.id}>
                <b>{v.typeLabel}</b>
                <span>{v.callSign ?? (v.radioIdentifier ? 'Kurzkennung ' + v.radioIdentifier + ' · vollständiger Rufname offen' : 'Funkrufname nicht veröffentlicht')}</span>
                <small>
                  {v.availability === 'planned'
                    ? 'Geplant · nicht disponierbar'
                    : v.availability === 'historical'
                      ? 'Historisch · nicht disponierbar'
                      : v.availability === 'unconfirmed'
                        ? 'Angabe widersprüchlich · nicht disponierbar'
                        : v.unitOnly
                          ? 'Einheit belegt · kein Fahrzeug nachgewiesen'
                          : v.kind
                          ? 'Fahrzeugtyp im Simulator abgebildet'
                          : 'Dokumentiert · Fahrzeugtyp noch nicht disponierbar'}
                </small>
                {v.note && <small>{v.note}</small>}
                <a href={v.sourceUrl} target="_blank" rel="noreferrer">
                  Fahrzeugquelle ↗
                </a>
              </div>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}
